import styled from "styled-components";

export const Wrapper = styled.div`
  //setando a cor que é utilizada no icone devido a um bug no DS que não está colocando a cor certa
  --color-neutral-600: ${p => p.color};
`